export const APP_VERSION_URL = '/assets/version.json';
